import { PinSwitchStatic } from '@lessonup/pin-renderer';
import { isQuizTeacherPin, Pin } from '@lessonup/pins-shared';
import React from 'react';
import { AnswerByCategoryPinEditor } from '../../../PinEditor/PinSwitchEditor/pins/AnswerByCategoryPinEditor';
import { QuizPinEditor } from '../../../PinEditor/PinSwitchEditor/pins/QuizPinEditor';

interface PinSwitchStaticPinRailProps {
  pin: Pin;
  children: React.ReactNode;
}
export const PinSwitchStaticPinRail: React.FC<PinSwitchStaticPinRailProps> = ({ pin, children }) => {
  switch (pin.type) {
    case 'MULTIPLE_CHOICE':
      if (!isQuizTeacherPin(pin)) {
        return null;
      }
      return (
        <QuizPinEditor pinSettings={pin.settings} pin={pin} isThumb>
          {children}
        </QuizPinEditor>
      );
    case 'ANSWER_BY_CATEGORY':
      return (
        <AnswerByCategoryPinEditor pinSettings={pin.settings} isThumb>
          {children}
        </AnswerByCategoryPinEditor>
      );
    default:
      return PinSwitchStatic({ pin, children });
  }
};
